import { createFileRoute } from '@tanstack/react-router'
import AgentPanel from '@/components/organisms/AgentPanel'

export const Route = createFileRoute('/_authenticated/phone/agents')({
  component: AgentPanel,
})
